import { render } from "./StepFive.vue?vue&type=template&id=22aaf79a&scoped=true"
import script from "./StepFive.vue?vue&type=script&lang=js"
export * from "./StepFive.vue?vue&type=script&lang=js"

import "./StepFive.vue?vue&type=style&index=0&id=22aaf79a&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22aaf79a"]])

export default __exports__